import { HttpError, isHttpError, isHttpErrorCode, JsonApiRequestError } from '@farfetched/core';
import { z, ZodType } from 'zod';

export type WithError<T = unknown, P = Record<string, unknown>> = P & {
	error: T;
};

export type HttpErrorResponse<TStatus extends number = number, TMessage extends string = string> = {
	error: string;
	statusCode: TStatus;
	message: TMessage;
};

export const httpErrorResponseSchema: ZodType<HttpErrorResponse> = z.object({
	error: z.string(),
	statusCode: z.number(),
	message: z.string(),
});

export const isHttpErrorResponse = (res: HttpError['response']): res is HttpErrorResponse =>
	httpErrorResponseSchema.safeParse(res).success;

export type NotHttpError = Exclude<JsonApiRequestError, HttpError>;

export const isNotHttpError = (args: WithError): args is WithError<NotHttpError> =>
	!isHttpError(args);

export type HttpErrorWithResponse<TStatus extends number = number> = Omit<
	HttpError<TStatus>,
	'response'
> & {
	response: HttpErrorResponse;
};

export const isHttpErrorWithResponse = (
	args: WithError,
): args is WithError<HttpErrorWithResponse> =>
	isHttpError(args) && isHttpErrorResponse(args.error.response);

export const isUnauthorizedError = isHttpErrorCode(401);
